import { VpGlAccount } from '../models/vp-gl-account.model';

// WI 34966: the NCR GL account typeahead searches the Viewpoint GL accounts of the user's
// default company. The API resolves the GL company and does the remote match.

/** The most accounts one search returns. Kendo and the mobile list both show a short list. */
export const GL_ACCOUNT_SEARCH_TOP = 25;

/** An account as the API returns it (camelCase Account DTO). */
export type VpGlAccountRecord = Pick<VpGlAccount, 'glAcct' | 'companyID'> & {
  description?: string | null;
};

/** The record with the `name` label both platforms render: the number, then the description. */
export function toVpGlAccount(record: VpGlAccountRecord): VpGlAccount {
  const description = record.description ?? '';
  return {
    glAcct: record.glAcct,
    description,
    companyID: record.companyID,
    name: description ? `${record.glAcct} ${description}` : record.glAcct,
  };
}

/** Local match for the offline path, the API's rule: number starts with the term, or description contains it. */
export function glAccountMatchesQuery(query: string, data: unknown): boolean {
  const term = `${query ?? ''}`.trim().toLowerCase();
  if (!term) {
    return true;
  }
  if (!data || typeof data !== 'object') {
    return false;
  }
  const account = data as Partial<VpGlAccount>;
  return (
    (account.glAcct ?? '').toLowerCase().startsWith(term) ||
    (account.description ?? '').toLowerCase().includes(term)
  );
}
